export const mapGetOrCreate = <M extends Map<any, any>>(map: M, key: Parameters<M["get"]>[0], create: () => NonNullable<ReturnType<M["get"]>>): NonNullable<ReturnType<M["get"]>> => {
	let value = map.get(key);
	if (value == null) {
		value = create();
		map.set(key, value);
	}
	return value;
}

export const mapGetOrCreateAsync = async <M extends Map<any, any>>(
	map: M,
	key: Parameters<M["get"]>[0],
	create: () => Promise<NonNullable<ReturnType<M["get"]>>>
): Promise<NonNullable<ReturnType<M["get"]>>> => {
	let value = map.get(key);
	if (value == null) {
		value = await create();
		map.set(key, value);
	}
	return value;
}

export const toMap = <T, K>(iterable: Iterable<T>, key: (t: T) => K): Map<K, T[]> => {
	const map = new Map<K, T[]>();
	for (const t of iterable) {
		mapGetOrCreate(map, key(t), () => []).push(t);
	}
	return map;
}